var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "content is-small lane-review-content" }, [
    _vm.isPopup
      ? _c("div", { staticClass: "has-text-centered mb-2" }, [
          _c("h3", { staticClass: "title is-6 mb-1 has-text-left" }, [
            _vm._v(_vm._s(_vm.lane.name)),
          ]),
        ])
      : _c("div", [
          _c("h3", { staticClass: "title is-5 has-text-left" }, [
            _vm._v("Review Lane Details"),
          ]),
        ]),
    _c("div", { staticClass: "tabs is-small is-success" }, [
      _c("ul", [
        _c("li", { class: { "is-active": _vm.activeTab === "basic" } }, [
          _c(
            "a",
            {
              on: {
                click: function ($event) {
                  _vm.activeTab = "basic"
                },
              },
            },
            [_vm._v("Basic Info")]
          ),
        ]),
        _c("li", { class: { "is-active": _vm.activeTab === "segments" } }, [
          _c(
            "a",
            {
              on: {
                click: function ($event) {
                  _vm.activeTab = "segments"
                },
              },
            },
            [_vm._v("Segments")]
          ),
        ]),
        _c("li", { class: { "is-active": _vm.activeTab === "additional" } }, [
          _c(
            "a",
            {
              on: {
                click: function ($event) {
                  _vm.activeTab = "additional"
                },
              },
            },
            [_vm._v("Additional Details")]
          ),
        ]),
      ]),
    ]),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.activeTab === "basic",
            expression: "activeTab === 'basic'",
          },
        ],
        staticStyle: { "min-height": "260px" },
      },
      [
        _c("p", { staticClass: "detail-row" }, [
          _c("strong", [_vm._v("Name:")]),
          _vm._v(" " + _vm._s(_vm.lane.name)),
        ]),
        _c("p", { staticClass: "detail-row" }, [
          _c("strong", [_vm._v("Distribution Zones:")]),
          _vm._v(
            " " +
              _vm._s(
                _vm.selectedHubs
                  .map((hub) => hub.DistributionZoneName)
                  .join(" → ")
              )
          ),
        ]),
        _c("p", { staticClass: "detail-row" }, [
          _c("strong", [_vm._v("Total Lead Time:")]),
          _vm._v(" " + _vm._s(_vm.lane.totalLeadTime) + " days"),
        ]),
        _c("p", { staticClass: "detail-row" }, [
          _c("strong", [_vm._v("Capacity:")]),
          _vm._v(" " + _vm._s(_vm.lane.capacity)),
        ]),
        _c("p", { staticClass: "detail-row" }, [
          _c("strong", [_vm._v("Cost:")]),
          _vm._v(" $" + _vm._s(_vm.lane.cost)),
        ]),
      ]
    ),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.activeTab === "segments",
            expression: "activeTab === 'segments'",
          },
        ],
        staticStyle: { "min-height": "260px" },
      },
      [
        _c("div", { staticClass: "box has-background-light p-2 mb-2" }, [
          _c("h4", { staticClass: "title is-6 has-text-left mb-1" }, [
            _vm._v("Segments"),
          ]),
          _c(
            "div",
            {
              staticClass: "carousel-container",
              staticStyle: { overflow: "hidden", position: "relative" },
            },
            [
              _c(
                "div",
                {
                  staticClass: "carousel-slide",
                  staticStyle: { transition: "transform 0.3s ease" },
                },
                [
                  _vm.lane.segments.length > 0
                    ? _c("div", { staticClass: "mb-2" }, [
                        _c("p", { staticClass: "detail-row" }, [
                          _c("strong", [
                            _vm._v(
                              _vm._s(
                                _vm.lane.segments[_vm.currentSegmentIndex].from
                                  .DistributionZoneName
                              ) +
                                " → " +
                                _vm._s(
                                  _vm.lane.segments[_vm.currentSegmentIndex].to
                                    .DistributionZoneName
                                )
                            ),
                          ]),
                        ]),
                        _c("p", { staticClass: "detail-row" }, [
                          _vm._v(
                            "Lead Time: " +
                              _vm._s(
                                _vm.lane.segments[_vm.currentSegmentIndex]
                                  .leadTime
                              ) +
                              " days "
                          ),
                        ]),
                        _c("div", { staticClass: "detail-section" }, [
                          _c("strong", [_vm._v("Vehicle Restrictions:")]),
                          _vm.lane.segments[_vm.currentSegmentIndex]
                            .vehicleTypeRestrictions &&
                          _vm.lane.segments[_vm.currentSegmentIndex]
                            .vehicleTypeRestrictions.length
                            ? _c(
                                "ul",
                                { staticClass: "detail-list" },
                                _vm._l(
                                  _vm.lane.segments[_vm.currentSegmentIndex]
                                    .vehicleTypeRestrictions,
                                  function (restriction) {
                                    return _c("li", { key: restriction }, [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.getVehicleTypeRestrictionLabel(
                                              restriction
                                            )
                                          ) +
                                          " "
                                      ),
                                    ])
                                  }
                                ),
                                0
                              )
                            : _c("span", [_vm._v("None")]),
                        ]),
                        _c("p", { staticClass: "detail-row" }, [
                          _vm._v(
                            "Max Weight: " +
                              _vm._s(
                                _vm.lane.segments[_vm.currentSegmentIndex]
                                  .loadRestrictions.maxWeight || "Not specified"
                              ) +
                              " "
                          ),
                        ]),
                        _c("p", { staticClass: "detail-row" }, [
                          _vm._v(
                            "Hazardous Materials: " +
                              _vm._s(
                                _vm.lane.segments[_vm.currentSegmentIndex]
                                  .loadRestrictions.hazardousMaterials
                                  ? "Restricted"
                                  : "Allowed"
                              )
                          ),
                        ]),
                      ])
                    : _c("div", { staticClass: "has-text-centered" }, [
                        _vm._v(" No segments defined "),
                      ]),
                ]
              ),
            ]
          ),
          _vm.lane.segments.length > 1
            ? _c(
                "div",
                {
                  staticClass: "is-flex is-justify-content-space-between mb-1",
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "button is-small",
                      attrs: { disabled: _vm.currentSegmentIndex === 0 },
                      on: { click: _vm.prevSegment },
                    },
                    [_vm._m(0)]
                  ),
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.currentSegmentIndex + 1) +
                        " / " +
                        _vm._s(_vm.lane.segments.length)
                    ),
                  ]),
                  _c(
                    "button",
                    {
                      staticClass: "button is-small",
                      attrs: {
                        disabled:
                          _vm.currentSegmentIndex >=
                          _vm.lane.segments.length - 1,
                      },
                      on: { click: _vm.nextSegment },
                    },
                    [_vm._m(1)]
                  ),
                ]
              )
            : _vm._e(),
        ]),
      ]
    ),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.activeTab === "additional",
            expression: "activeTab === 'additional'",
          },
        ],
        staticStyle: { "min-height": "260px" },
      },
      [
        _c("p", { staticClass: "detail-row" }, [
          _c("strong", [_vm._v("Freight Type:")]),
          _vm._v(
            " " +
              _vm._s(
                _vm.lane.freightType.length
                  ? _vm.lane.freightType.join(", ")
                  : "None specified"
              )
          ),
        ]),
        _c("p", { staticClass: "detail-row" }, [
          _c("strong", [_vm._v("Time-of-Day Restrictions:")]),
          _vm._v(" " + _vm._s(_vm.lane.timeOfDayRestrictions || "None")),
        ]),
        _c("div", { staticClass: "detail-section" }, [
          _c("strong", [_vm._v("Environmental Considerations:")]),
          _vm.lane.environmentalConsiderations &&
          _vm.lane.environmentalConsiderations.length
            ? _c(
                "ul",
                { staticClass: "detail-list" },
                _vm._l(
                  _vm.lane.environmentalConsiderations,
                  function (consideration) {
                    return _c("li", { key: consideration }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.getEnvironmentalConsiderationLabel(
                              consideration
                            )
                          ) +
                          " "
                      ),
                    ])
                  }
                ),
                0
              )
            : _c("span", [_vm._v("None")]),
        ]),
        _c("div", { staticClass: "detail-section" }, [
          _c("strong", [_vm._v("Technology Integration:")]),
          _vm.lane.technologyIntegration &&
          _vm.lane.technologyIntegration.length
            ? _c(
                "ul",
                { staticClass: "ml-4 mb-0 mt-0 pl-3" },
                _vm._l(_vm.lane.technologyIntegration, function (tech) {
                  return _c("li", { key: tech }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm.getTechnologyIntegrationLabel(tech)) +
                        " "
                    ),
                  ])
                }),
                0
              )
            : _c("span", [_vm._v("None")]),
        ]),
        _c("p", { staticClass: "detail-row" }, [
          _c("strong", [_vm._v("Platooning:")]),
          _vm._v(
            " " +
              _vm._s(
                _vm.lane.platooningRegulations.allowed
                  ? "Allowed"
                  : "Not allowed"
              )
          ),
        ]),
        _vm.lane.platooningRegulations.allowed
          ? _c("p", { staticClass: "detail-row" }, [
              _c("strong", [_vm._v("Minimum Following Distance:")]),
              _vm._v(
                " " +
                  _vm._s(_vm.lane.platooningRegulations.minFollowingDistance) +
                  " meters "
              ),
            ])
          : _vm._e(),
      ]
    ),
    _vm.isPopup
      ? _c("div", { staticClass: "is-flex is-justify-content-flex-end mt-2" }, [
          _c("div", { staticClass: "buttons" }, [
            _c(
              "button",
              {
                staticClass: "button is-small is-danger",
                class: { "is-loading": _vm.isDeleting },
                staticStyle: { "border-radius": "5px" },
                on: {
                  click: function ($event) {
                    return _vm.deleteLane(_vm.lane.id)
                  },
                },
              },
              [_vm._v(" Delete ")]
            ),
            _c(
              "button",
              {
                staticClass: "button is-small is-primary mr-2",
                class: { "is-loading": _vm.isDeleting },
                staticStyle: { "border-radius": "5px" },
                on: { click: _vm.editLane },
              },
              [_vm._v(" Edit ")]
            ),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon is-small" }, [
      _c("i", { staticClass: "fas fa-chevron-left" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon is-small" }, [
      _c("i", { staticClass: "fas fa-chevron-right" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }